
import { defineComponent, ref } from 'vue';

export default defineComponent({
	name: 'CardInfo',
	props: {
		infoData: {
			type: [String, Object],
			default: '',
		},
	},
	setup() {
		const forms = ref([
			{
				id: '1',
				description: 'Total de Fluxos Criados',
				type: 'flow',
			},
			{
				id: '2',
				description: 'Fluxos Com Sucesso',
				type: 'successFlow',
			},
			{
				id: '3',
				description: 'Fluxos Com Alerta',
				type: 'alertFlow',
			},
			{
				id: '4',
				description: 'Fluxos Com Falha',
				type: 'errorFlow',
			},
			{
				id: '5',
				description: 'Outros',
				type: 'othersFlow',
			},
		]);

		const path = (type: string) => {
			let payload = {
				name: 'executionLog',
				query: {
					ultimaExecucao: true,
					excetoExecucoesAnexadas: false,
					fluxoAtivos: true,
					resultado: '' as string | string[],
				},
			};
			if (type === 'successFlow') {
				payload.query.resultado = 'Sucesso';
			} else if (type === 'alertFlow') {
				payload.query.resultado = 'Alerta';
			} else if (type === 'errorFlow') {
				payload.query.resultado = 'Falha';
			} else if (type === 'othersFlow') {
				payload.query.resultado = ['Nao_Armazenado', 'Interrompido'];
			} 
			if (!!payload.query.resultado) {
				return payload;
			} else {
				return '';
			}
		};

		return {
			forms,
			path,
		};
	},
});
